<template>
  <nav aria-label="Page navigation" v-if="numberPages > 1" class="mt-2">
    <ul class="pagination justify-content-end">
      <li class="page-item" v-bind:class="{ disabled: localCurrentPage == 0 }" @click="chooseEventFirstPage()">
        <span class="page-link" tabindex="-1">Primera</span>
      </li>
      <li class="page-item" v-bind:class="{ disabled: localCurrentPage == 0 }" @click="chooseEventPrevPage()">
        <span class="page-link" tabindex="-1">{{ $store.state.responsive.viewDesktopFilters ? 'Siguiente': '&lt;'}}</span>
      </li>
      <template v-if="$store.state.responsive.viewDesktopFilters">
        <li v-for="index in maxLimitPages" v-bind:key=index class="page-item"
        @click="clickNumberPage(index + minLimit); selectPage();" v-bind:class="{ active: index + minLimit == localCurrentPage + 1 }">
          <span class="page-link" href="">{{index + minLimit}}</span>
        </li>
      </template>
      <li class="page-item" v-bind:class="{ disabled: localCurrentPage >= numberPages - 1 }"
        @click="chooseEventNextPage()">
        <span class="page-link">{{ $store.state.responsive.viewDesktopFilters ? 'Siguiente': ">"}}</span>
      </li>
      <li class="page-item" v-bind:class="{ disabled: localCurrentPage >= numberPages - 1 }"
        @click="chooseEventLastPage()">
        <span class="page-link">Última</span>
      </li>
    </ul>
  </nav>
</template>

<script>

export default {
  name: 'Pagination',
  props: [
    'numberPages',
    'currentPage',
  ],
  data() {
    return {
      maxPages: 9,
      maxLimitPages: 0,
      minLimit: 0,
      localCurrentPage: this.currentPage,
    };
  },
  created() {
    this.updated();
  },
  updated() {
    this.updated();
    console.log(this.currentPage);
  },
  methods: {
    updated(){
      this.maxLimitPages = this.numberPages > this.maxPages ? this.maxPages : this.numberPages;
      this.localCurrentPage = this.currentPage;
      this.generatePagination();
    },
    selectPage() {
      this.generatePagination();
      this.$emit('selectPage', this.localCurrentPage);
    },
    chooseEventFirstPage() {
      if (this.localCurrentPage > 0) {
        this.localCurrentPage = 0;
        this.selectPage();
      }
    },
    chooseEventPrevPage() {
      if (this.localCurrentPage > 0) {
        this.localCurrentPage -= 1;
        this.selectPage();
      }
    },
    chooseEventNextPage() {
      if (this.localCurrentPage < this.numberPages) {
        this.localCurrentPage += 1;
        this.selectPage();
      }
    },
    chooseEventLastPage() {
      if (this.localCurrentPage < this.numberPages) {
        this.localCurrentPage = this.numberPages - 1;
        this.selectPage();
      }
    },
    clickNumberPage(index) {
      this.localCurrentPage = index - 1;
    },
    generatePagination(){
      if(this.numberPages > this.maxPages){

        if(this.localCurrentPage < ((this.maxPages - 1) / 2)) {
          this.minLimit = 0
        }
        else if(this.localCurrentPage >= (this.numberPages - ((this.maxPages - 1) / 2))){
          this.minLimit = this.numberPages - this.maxPages;
        }
        else{
          this.minLimit = this.localCurrentPage - ((this.maxPages - 1) / 2)
        }
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
